import { useCallback, useEffect, useState } from 'react';
import comissaoPresetService from 'features/comercial/services/comissaoPresetService';
import { getCompanyContext } from 'utils/setCompanyContext';

export default function useComissaoPresets() {
  const [presets, setPresets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const empresaAtual = () => getCompanyContext()?.companies?.[0]?.name || 'MOV Fibra';

  const recarregar = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await comissaoPresetService.listar(empresaAtual());
    if (res.success) {
      setPresets(res.data || []);
    } else {
      setError(res.error);
      setPresets([]);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    recarregar();
    const handler = () => recarregar();
    window.addEventListener('company-changed', handler);
    return () => window.removeEventListener('company-changed', handler);
  }, [recarregar]);

  const criar = useCallback(async (dados) => {
    const res = await comissaoPresetService.criar({ ...dados, empresa: empresaAtual() });
    if (res.success) await recarregar();
    return res;
  }, [recarregar]);

  const atualizar = useCallback(async (id, dados) => {
    const res = await comissaoPresetService.atualizar(id, { ...dados, empresa: empresaAtual() });
    if (res.success) await recarregar();
    return res;
  }, [recarregar]);

  const remover = useCallback(async (id) => {
    const res = await comissaoPresetService.remover(id, empresaAtual());
    if (res.success) await recarregar();
    return res;
  }, [recarregar]);

  return { presets, loading, error, recarregar, criar, atualizar, remover };
}
